import { createAction } from '@reduxjs/toolkit';

export const setLoading = createAction('firestopDocumentation/setLoading');

export const resetDefects = createAction('firestopDocumentation/resetDefects');

export const setDefectState = createAction(
  'firestopDocumentation/setDefectState'
);

export const setSnackBarState = createAction(
  'firestopDocumentation/setSnackBarState'
);

export const setCompanyLogo = createAction(
  'firestopDocumentation/setCompanyLogo'
);

export const clearDefectState = createAction(
  'firestopDocumentation/clearDefectState'
);

export const openCreateFirestopListDialog = createAction(
  'firestopDocumentation/openCreateFirestopListDialog'
);

export const closeCreateFirestopListDialog = createAction(
  'firestopDocumentation/closeCreateFirestopListDialog'
);

export const addFirestopItemToCreate = createAction(
  'firestopDocumentation/addFirestopItemToCreate'
);

export const modifyFirestopItemToCreate = createAction(
  'firestopDocumentation/modifyFirestopItemToCreate'
);

export const modifyFirestopAdditionAttribute = createAction(
  'firestopDocumentation/modifyFirestopAdditionAttribute'
);

export const modifyDefectAdditionAttributes = createAction(
  'firestopDocumentation/modifyDefectAdditionAttributes'
);

export const editFirestopAttributes = createAction(
  'firestopDocumentation/editFirestopAttributes'
);

export const openFirestopList = createAction(
  'firestopDocumentation/openFirestopList'
);

export const modfiyDefectList = createAction(
  'firestopDocumentation/modifyDefectList'
);

export const setDefectAssignation = createAction(
  'firestopDocumentation/setDefectAssignation'
);

export const setDefectEditAssignation = createAction(
  'firestopDocumentation/setDefectEditAssignation'
);

export const setMultipleDefectAssignation = createAction(
  'firestopDocumentation/setMultipleDefectAssignation'
);

export const removeDefectAssignation = createAction(
  'firestopDocumentation/removeDefectAssignation'
);

export const removeDefectEditAssignation = createAction(
  'firestopDocumentation/removeDefectEditAssignation'
);

export const closeViewAndEditFirestopListDialog = createAction(
  'firestopDocumentation/closeViewAndEditFirestopListDialog'
);

export const toggleEditListAttributes = createAction(
  'firestopDocumentation/toggleEditListAttributes'
);

export const modifyFirestopListAttribute = createAction(
  'firestopDocumentation/modifyFirestopListAttribute'
);

export const openAddNewFirestopDialog = createAction(
  'firestopDocumentation/openAddNewFirestopDialog'
);

export const closeAddNewFirestopsDialog = createAction(
  'firestopDocumentation/closeAddNewFirestopsDialog'
);

export const openConfirmFirestopItemDeleteDialog = createAction(
  'firestopDocumentation/openConfirmFirestopItemDeleteDialog'
);

export const closeConfirmFirestopItemDeleteDialog = createAction(
  'firestopDocumentation/closeConfirmFirestopItemDeleteDialog'
);

export const openConfirmFirestopListDeleteDialog = createAction(
  'firestopDocumentation/openConfirmFirestopListDeleteDialog'
);

export const closeConfirmFirestopListDeleteDialog = createAction(
  'firestopDocumentation/closeConfirmFirestopListDeleteDialog'
);

export const openEditDefectItemDialog = createAction(
  'firestopDocumentation/openEditDefectItemDialog'
);

export const closeEditDefectItemDialog = createAction(
  'firestopDocumentation/closeEditDefectItemDialog'
);

export const setFirestopImageToAdd = createAction(
  'firestopDocumentation/setFirestopImageToAdd'
);

export const setDefectImageToDelete = createAction(
  'firestopDocumentation/setDefectImageToDelete'
);

export const openDefectItemFixDialog = createAction(
  'firestopDocumentation/openDefectItemFixDialog'
);
export const openDefectAssigneeSwitchDialog = createAction(
  'firestopDocumentation/openDefectAssigneeSwitchDialog'
);

export const closeDefectAssigneeSwitchDialog = createAction(
  'firestopDocumentation/closeDefectAssigneeSwitchDialog'
);

export const closeDefectItemFixDialog = createAction(
  'firestopDocumentation/closeDefectItemFixDialog'
);

export const openFirestopAdditionDialog = createAction(
  'firestopDocumentation/openFirestopAdditionDialog'
);
export const closeFirestopAdditionDialog = createAction(
  'firestopDocumentation/closeFirestopAdditionDialog'
);

export const setIsCreatingOrUpdatingFirestopData = createAction(
  'firestopDocumentation/setIsCreatingOrUpdatingFirestopData'
);

export const setFirestopImageDescription = createAction(
  'firestopDocumentation/setFirestopImageDescription'
);

export const removeFirestopImageDescription = createAction(
  'firestopDocumentation/removeFirestopImageDescription'
);

export const setIsPrintingFirestopListPdf = createAction(
  'firestopDocumentation/setIsPrintingFirestopListPdf'
);
